import { SxProps } from "@mui/material";
import { useEffect, useState } from "react";
import { StatusPicker, IssueStatusChangedDialogContent, useDialog } from "src/components";
import { ClosedIssueStatuses, DEFAULT_TASK_ITEM_STATUS, IssueStatus, ISSUE_STATUSES } from "src/constants";
import { useEditIssueStatus } from "src/http";

interface IProps {
  variant: "button" | "select";
  issueGuid?: string;
  status: IssueStatus;
  teamSlug?: string;
  createdByUserGuid?: string;
  disabled?: boolean;
  sx?: SxProps;
}

const IssueStatusPicker = (props: IProps) => {
  const [selectedStatus, setSelectedStatus] = useState<IssueStatus>(props.status ?? DEFAULT_TASK_ITEM_STATUS);
  const { mutate: editIssueStatus } = useEditIssueStatus();
  const { showDialog, closeDialog } = useDialog();

  useEffect(() => {
    setSelectedStatus(props.status ?? DEFAULT_TASK_ITEM_STATUS);
  }, [props.status]);

  async function handleStatusChanged(newSelectedStatus: IssueStatus) {
    setSelectedStatus(newSelectedStatus);

    if (props.issueGuid === undefined || props.createdByUserGuid === undefined) {
      return;
    }

    if (newSelectedStatus !== IssueStatus.Open) {
      showDialog({
        content: (
          <IssueStatusChangedDialogContent
            issueGuid={props.issueGuid}
            status={newSelectedStatus}
            onDone={closeDialog}
            onCancel={closeDialog}
          />
        ),
      });
    }

    await editIssueStatus({
      issueGuid: props.issueGuid,
      statusId: newSelectedStatus,
      teamSlug: props.teamSlug,
      createdByUserId: props.createdByUserGuid,
    });
  }

  return (
    <StatusPicker
      variant={props.variant}
      disabled={props.disabled}
      value={selectedStatus}
      options={ISSUE_STATUSES.sort((a, b) => (a.sortOrder > b.sortOrder ? 1 : 0))}
      groupBy={(option) => (ClosedIssueStatuses.includes(option.id) ? "Closed Statuses" : "Active Statuses")}
      onChange={handleStatusChanged}
      sx={{ ...props.sx }}
    />
  );
};

export { IssueStatusPicker };
